import {types} from './types';

const setGetViewKeysAction = (payload) => {
    return {
        type: types.SET_VIEW_KEYS,
        payload,
      }
}

export {
  setGetViewKeysAction
}
